<template>
    <div>
        <Navbar/>
        <div class="p-4">
            <div class="d-flex mb-4 text-darker justify-content-evenly">
            <a href="#" class="text-secondary text-decoration-none">
                <i class="fas fa-search"></i> Szukaj
            </a>
            <a href="#" class="text-primary text-decoration-none">
                <i class="fas fa-sync"></i> Odśwież
            </a>
            </div>
            <hr>
            <div class="row">
            <div class="d-lg-flex my-2 justify-content-between">
                <div>
                  <h5>
                    <router-link :to="{ name: 'DriversListing' }" class="text-decoration-none fw-bold">
                        Lista kierowców
                    </router-link>
                    <i class="fa-solid fa-circle-arrow-right mx-3"></i>
                  </h5>
                  <h5 class="fw-bold">
                    Dodaj kierowcę
                  </h5>
                </div>
                <div>
                    <router-link :to="{ name: 'DriversListing' }" class="btn btn-primary">
                        Powrót do listy kierowców
                    </router-link>
                </div>
            </div>
            </div>
        </div>
        <h2>
            Dodaj kierowcę
        </h2>

        <div>
            <form @submit.prevent="AddDriver">
                <input
                    type="text"
                    class="form-control mt-4 w-50 mx-auto"
                    required
                    placeholder="Imię"
                    name=""
                    v-model="driver.firstName"
                >
                <input
                    type="text"
                    class="form-control mt-4 w-50 mx-auto"
                    required
                    placeholder="Nazwisko"
                    name=""
                    v-model="driver.surname"
                >
                <input
                    type="text"
                    class="form-control mt-4 w-50 mx-auto"
                    placeholder="Nr karty"
                    v-model="driver.cardNumber"
                    required    
                >
                <input
                    type="text"
                    class="form-control mt-4 w-50 mx-auto"
                    placeholder="Nr kierunkowy"
                    v-model="driver.phonePrefix"
                    required    
                >
                <input
                    type="text"
                    class="form-control mt-4 w-50 mx-auto"
                    placeholder="Nr telefonu"
                    v-model="driver.phoneNumber"
                    required
                >
                <input
                    type="text"
                    class="form-control mt-4 w-50 mx-auto"
                    placeholder="numer dowodu osobistego"
                    v-model="driver.workNumber"
                    required
                >

                <button role="submit" class="btn btn-primary mt-5 w-50" >
                    Dodaj
                </button>
                <div class="pb-3" />
            </form>
        </div>
    </div>
</template>

<script>
import Navbar from '../../components/Navbar.vue'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  components: {
    Navbar
  },
  data () {
    return {
      driver: {},
      allDrivers: []
    }
  },
  mounted () {
    this.fetchDrivers()
  },
  methods: {
    fetchDrivers () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}Driver`, config)
        .then(response => {
          this.allDrivers = response.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    AddDriver () {
      const similarDriver = this.allDrivers.filter(driver => {
        // eslint-disable-next-line no-mixed-operators
        return driver.phoneNumber === this.driver.phoneNumber || driver.firstName === this.driver.firstName && driver.surname === this.driver.surname
      })

      if (similarDriver.length !== 0) {
        Swal.fire('Uwaga', 'Nie można dodać dwóch takich samych kierowców.', 'warning')
        return
      }

      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      axios.post(process.env.VUE_APP_API_BASE_URL + 'Driver', this.driver, config)
        .then(response => {
          Swal.fire({
            title: 'Dodano kierowcę',
            type: 'success',
            confirmButtonText: 'OK',
            icon: 'success'
          })

          this.$router.push({ name: 'DriversListing' })
        })
        .catch(err => {
          console.log(err)
          Swal.fire('Kierowca został już dodany', '', 'info')
        })
    }
  }
}

</script>

<style scoped>
.btn {
    width: 150px;
}
</style>
